import { render, staticRenderFns } from "./SidebarNavigation.vue?vue&type=template&id=132440ac"
import script from "./SidebarNavigation.vue?vue&type=script&lang=js"
export * from "./SidebarNavigation.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavigation.vue?vue&type=style&index=0&id=132440ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports